<div class="autocomplete-container">
  <mat-form-field floatLabel="auto" class="autocomplete-searchbox">
    <input
      type="text"
      [placeholder]="placeholder | translate"
      matInput
      [formControl]="myControl"
      [matAutocomplete]="auto"
    />
    <span class="search-icon">
      <firebird-web-icon [name]="'search'" width="12px"></firebird-web-icon>
    </span>
    <mat-autocomplete class="autocomplete-box" #auto="matAutocomplete">
      @if (isLoading) {
      <mat-option translate="loading"></mat-option>
      } @if ( !isLoading && (myControl!.value?.length || 0) >= 3 &&
      filteredResults.length === 0) {
      <mat-option>{{ 'noResults' | translate }}</mat-option>
      } @else { @for (result of filteredResults; track trackByFnGroup($index)) {
      <mat-option
        (onSelectionChange)="selectionChange(result)"
        [value]="result.displayName"
      >
        {{ getSiteDisplayText(result) }}
      </mat-option>
      } }
    </mat-autocomplete>
  </mat-form-field>
</div>
